import dotProp from "dot-prop";
import { actions } from "../react-redux-form";
import { getCurrentOffice } from "../selectors/offices";
import scopedRecordSchema from "./scopedRecordSchema";

const ON_APPOINTMENT_CREATION = -1

const defaultTexts = (minutesNotice, office) => {
  const kind = Number(minutesNotice) === ON_APPOINTMENT_CREATION ? 'confirmation' : 'reminder'
  return {
    subject: I18n.t(`api.consultation_reminders.default_${kind}_subject`),
    body: I18n.t(`api.consultation_reminders.default_${kind}_template`, {office: office.name})
  }
}

const templateSchema = function(state, props) {
  const minutesNotice = dotProp.get(state, `entities.consultationReminder.byId.${props.entityId}.minutesNotice`)

  return {
    "subject": {
      "ui:autofocus": true,
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:options": {
        width: 6
      }
    },
    "body": {
      "ui:widget": "HtmlWidget",
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:options": {
        width:12,
        // remount the editor when the timing changes, so a swapped-in default body shows up
        editorKey: minutesNotice,
        mentionOptions: ["patient_first_name", "patient_last_name", "consultation_date", "consultation_hour", "location_address", "location_name"],
        mentionExamples: ["Sigmund", "Freud", "13/09/2023", "14:00", "Praktijk Het Voorbeeld, Voorbeeldstraat 23, 1000 Brussel", "Praktijk Het Voorbeeld"]
      },
    },
    "emailType":  {
      "ui:widget" : "hidden"
    },
    "officeId": {
      "ui:widget" : "hidden"
    }
  }

}

const consultationReminderSchema = function(state, props) {
  // Swap in the default subject/body for the chosen timing, but only while the text is still an untouched default
  let onSelectMinutesNotice = (minutesNotice) => {
    return function(dispatch, getState) {
      const state = getState()
      const office = getCurrentOffice(state)
      const templateId = dotProp.get(state, `entities.consultationReminder.byId.${props.entityId}.emailTemplateId`)
      const template = dotProp.get(state, `entities.emailTemplate.byId.${templateId}`)
      if (!template) return

      const defaults = [defaultTexts(ON_APPOINTMENT_CREATION, office), defaultTexts(0, office)]
      const newDefault = defaultTexts(minutesNotice, office)

      if (defaults.some(d => d.subject === template.subject)) {
        dispatch(actions.change(`entities.emailTemplate.byId.${templateId}.subject`, newDefault.subject))
      }
      if (defaults.some(d => d.body === template.body)) {
        dispatch(actions.change(`entities.emailTemplate.byId.${templateId}.body`, newDefault.body))
      }
    }
  }

  const uiSchema = {
    "ui:options": {
      "entityName": "consultationReminder",
    },
    "ui:order": ["active", "minutesNotice" , "*"],
    "emailTemplateId": {
      "ui:field": "NestedFormField",
      "ui:options": {
        "entityName": "emailTemplate",
        "displayTitle": false,
        "inline": true
      },
      "ui:schema": templateSchema(state, props)
    },
    "minutesNotice":{
      "ui:field": "SelectorField",
      "ui:options": {
        "entityName": "consultationReminder",
        "width": 3,
        "onSelect": onSelectMinutesNotice,
        "selectableOptions": ['-1', '30', '60', '120', '1440', '2880', '4320', '7200'],
      }
    },
    ...scopedRecordSchema(state,props)
  }

  return uiSchema
}

export default consultationReminderSchema;
